import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=modern%20entertainment%20media%20studio%20with%20dramatic%20dark%20atmosphere%2C%20multiple%20screens%20displaying%20news%20content%2C%20warm%20golden%20accent%20lighting%2C%20professional%20broadcast%20environment%2C%20cinematic%20composition%2C%20rich%20dark%20tones%20with%20amber%20highlights%2C%20elegant%20and%20mysterious%20vibe%2C%20no%20blue%20or%20purple%20colors&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="黑料视频 - 最新吃瓜爆料视频平台"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-[900px] px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
            最新<strong className="text-primary-400">吃瓜爆料</strong>视频
            <br />
            随时随地<strong className="text-accent-400">免费在线看</strong>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            聚合全网热门爆料视频，涵盖明星八卦、网红爆料、社会热点等多元内容。
            海量高清视频免费看，每日更新不停歇。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => {
                const el = document.getElementById('latest-videos');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观看
            </button>
            <button
              onClick={() => navigate('/category/mingxing-bagua')}
              className="px-8 py-3 rounded-full bg-white/10 hover:bg-white/20 text-white border border-white/30 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line mr-2"></i>
              热门爆料
            </button>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10 text-white/70 text-sm">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">10万+</div>
              <div>视频总量</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">500万+</div>
              <div>日活用户</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">每日更新</div>
              <div>7×24小时</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}